module.exports = __webpack_public_path__ + "static/heart-blue-4603cded0bc71da76ea87b68dc3debd2.png";